module.exports = __webpack_public_path__ + "static/media/logob.29fdc387.png";